export default function Login(){
    return(
        <div className="Login-page">
            <div className="Login-cnt">
                <h1>Login here</h1>
            </div>
        </div>
    )
}